import React from "react";
import { Link } from "react-router-dom";
import "../styles/footer.scss"; // keep if you're storing footer CSS here

const FooterThree = () => {
  return (
    <footer
      className="footer-wrapper footer-layout3"
      style={{ backgroundImage: "url(assets/img/bg/footer-bg3-1.png)" }}
    >
      <div className="container">
        <div className="widget-area">
          <div className="row justify-content-between">
            {/* Brand + blurb */}
            <div className="col-md-6 col-xl-3">
              <div className="widget footer-widget widget-about">
                <div className="about-logo">
                  <Link to="/">
                    <img
                      src="assets/img/kiubunifu_logo_white.png"
                      alt="Kiubunifu logo"
                    />
                  </Link>
                </div>

                <p className="logo-text">
                  Kiubunifu is a platform-powered company at the intersection of people, skills, technology, and work.
                </p>
              </div>
            </div>

            {/* Get in Touch */}
            <div className="col-md-7 col-lg-3">
              <div className="footer-widget contact-widget">
                <h3 className="widget_title">Get in Touch</h3>

                <ul className="contact-grid">
                  <li>
                    <span className="label">
                      <i className="fas fa-phone-alt" aria-hidden="true" />
                    </span>
                    <a className="value" href="tel:+256393162767">
                      +256&nbsp;393&nbsp;162&nbsp;767
                    </a>
                  </li>

                  <li>
                    <span className="label">
                      <i className="fab fa-whatsapp" aria-hidden="true" />
                    </span>
                    <a
                      className="value"
                      href="https://wa.me/+256751003997"
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      +256&nbsp;751&nbsp;003&nbsp;997
                    </a>
                  </li>

                  <li>
                    <span className="label">
                      <i className="fas fa-envelope" aria-hidden="true" />
                    </span>
                    <a
                      className="value"
                      href="mailto:customercare@kiubunifu.com"
                    >
                      customerservice@kiubunifu.com
                    </a>
                  </li>
                </ul>

                <div className="social-follow">
                  <h3 className="widget_title widget_title2">Follow Us</h3>
                  <div
                    className="social-btn style2"
                    aria-label="Social media"
                  >
                    {/* LinkedIn */}
                    <Link to="#" aria-label="LinkedIn">
                      <i className="fab fa-linkedin-in" />
                    </Link>

                    {/* Facebook */}
                    <Link to="#" aria-label="Facebook">
                      <i className="fab fa-facebook-f" />
                    </Link>

                    {/* Twitter / X */}
                    <Link to="#" aria-label="Twitter / X">
                      <i className="fab fa-twitter" />
                    </Link>

                    {/* YouTube */}
                    <Link to="#" aria-label="YouTube">
                      <i className="fab fa-youtube" />
                    </Link>

                    {/* WhatsApp */}
                    <Link to="#" aria-label="WhatsApp">
                      <i className="fab fa-whatsapp" />
                    </Link>

                    {/* Telegram */}
                    <Link to="#" aria-label="Telegram">
                      <i className="fab fa-telegram-plane" />
                    </Link>

                    {/* Instagram (keep if you still want it) */}
                    {/* 
                    <Link to="#" aria-label="Instagram">
                      <i className="fab fa-instagram" />
                    </Link>
                    */}
                  </div>
                </div>
              </div>
            </div>
            {/* /Get in Touch */}
          </div>
        </div>
      </div>

      <div className="copyright-wrap">
        <div className="container">
          <div className="row gy-3 justify-content-lg-between justify-content-center">
            <div className="col-auto align-self-center">
              <p className="copyright-text text-center">
                © <Link to="#">Kiubunifu</Link> 2026 | All Rights Reserved
              </p>
            </div>
            <div className="col-auto">
              <div className="footer-links">
                <Link to="/terms-of-use">Terms of Use</Link>
                <Link to="/privacy-policy">Privacy Policy</Link>
                <Link to="/cookies-policy">Cookies Policy</Link>
                <Link to="/contact">Contact Us</Link>
              </div>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default FooterThree;
